import { render, staticRenderFns } from "./IfTheyCanDoItSoCanYou.vue?vue&type=template&id=4250b0ec&"
import script from "./IfTheyCanDoItSoCanYou.vue?vue&type=script&setup=true&lang=js&"
export * from "./IfTheyCanDoItSoCanYou.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports